import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { EnhancedLogin } from './EnhancedLogin';
import './Login.css';

// 将用户从本地存储中清除的函数
export const clearUserFromLocalStorage = () => {
  localStorage.removeItem('user');
};

const Login = () => {
  const history = useHistory();
  const [loading, setLoading] = useState(false);

  // 处理登录成功
  const handleLoginSuccess = (user) => {
    setLoading(true);
    
    // 将用户信息保存到本地存储
    localStorage.setItem('user', JSON.stringify(user));
    
    // 重定向到主页
    setTimeout(() => {
      history.push('/');
    }, 1000);
  };

  return (
    <div className="elegant-auth-page">
      <div className="elegant-auth-content">
        <div className="elegant-auth-card">
          <div className="elegant-auth-header">
            <div className="elegant-auth-logo">灌汤社区 HugTub</div>
            <div className="elegant-auth-slogan">登录（未注册的手机号将自动注册）</div>
          </div>
          
          <div className="elegant-auth-form-container">
            <EnhancedLogin onLogin={handleLoginSuccess} />
          </div>
        </div>
        
        <div className="elegant-auth-decoration">
          <div className="elegant-auth-circle circle-1"></div>
          <div className="elegant-auth-circle circle-2"></div>
          <div className="elegant-auth-circle circle-3"></div>
          <div className="elegant-auth-circle circle-4"></div>
          <div className="elegant-auth-circle circle-5"></div>
          <div className="elegant-auth-wave"></div>
        </div>
      </div>
      
      {loading && (
        <div className="elegant-loading-overlay">
          <div className="elegant-loading-spinner"></div>
          <p className="elegant-loading-text">登录成功，正在跳转...</p>
        </div>
      )}
    </div>
  );
};

export default Login;